import React, { Fragment } from "react";
import { Button, Modal } from "react-bootstrap";
import { Formik } from "formik";

import EntitlementDetail from "components/EntitlementDetail";
import { VoucherStatus } from "constant";

export function DetailsModal({
  show,
  initialValues,
  onModalClose,
  onFormSubmit,
}) {
  const status = VoucherStatus[initialValues.status];
  const submitButtonText =
    status === VoucherStatus.Invalid ? "Validate" : "Invalidate";

  return (
    <Modal show={show} onHide={onModalClose} bsSize="large" backdrop="static">
      <Modal.Header>
        <Modal.Title>Voucher Details</Modal.Title>
      </Modal.Header>
      <Formik initialValues={initialValues} onSubmit={onFormSubmit}>
        {({ handleSubmit, isSubmitting }) => (
          <Fragment>
            <Modal.Body>
              <EntitlementDetail entitlement={initialValues} />
            </Modal.Body>
            <Modal.Footer>
              <div className="btn-toolbar pull-right">
                <button
                  className="btn btn-grey"
                  onClick={onModalClose}
                  disabled={isSubmitting}
                >
                  Close
                </button>
                <Button bsStyle="primary" onClick={handleSubmit}>
                  {submitButtonText}{" "}
                  {isSubmitting && <i className="fa fa-spinner fa-spin" />}
                </Button>
              </div>
            </Modal.Footer>
          </Fragment>
        )}
      </Formik>
    </Modal>
  );
}
